import { render } from "./ChartMedicineCabinet.vue?vue&type=template&id=6ae458fc"
import script from "./ChartMedicineCabinet.vue?vue&type=script&lang=js"
export * from "./ChartMedicineCabinet.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__